import { Clock, Mail, MapPin, Phone } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Seo } from "@/components/site/Seo";
import { Reveal } from "@/components/site/Reveal";
import { BUSINESS } from "@/lib/site";

const Contact = () => (
  <>
    <Seo
      title="Contact Us & Get a Free Quote | Oz SpotNest Cleaning Sydney"
      description="Request a free cleaning quote from Oz SpotNest Cleaning Service. Call 0451 415 328 or email info@ozspotnest.com.au — residential, commercial, NDIS & aged care cleaning across Sydney, NSW."
    />
    <PageHero
      eyebrow="Contact & quotes"
      title="Let's Get Your"
      highlight="Space Clean"
      description="Tell us what you need cleaned and we'll come back with a clear, obligation-free quote. Prefer to talk? We're available 7 days."
    />

    <section className="section-pad" id="quote" data-testid="contact-section">
      <div className="container-site grid gap-12 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <Reveal>
            <span className="eyebrow">Get in touch</span>
            <h2 className="mt-4 text-3xl font-bold tracking-tight sm:text-4xl">Contact Details</h2>
            <div className="mt-8 space-y-4">
              <a
                href={BUSINESS.phoneHref}
                data-testid="contact-phone-card"
                className="group flex items-center gap-4 rounded-2xl border border-slate-100 bg-white p-5 shadow-lg shadow-sky-900/5 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-emerald-50 text-emerald-600">
                  <Phone className="h-5 w-5" />
                </span>
                <span>
                  <span className="block text-xs font-bold uppercase tracking-[0.15em] text-slate-400">Call us</span>
                  <span className="block font-heading text-lg font-bold text-navy-800 group-hover:text-emerald-600">
                    {BUSINESS.phone}
                  </span>
                </span>
              </a>
              <a
                href={BUSINESS.emailHref}
                data-testid="contact-email-card"
                className="group flex items-center gap-4 rounded-2xl border border-slate-100 bg-white p-5 shadow-lg shadow-sky-900/5 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
              >
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-sky-50 text-sky-600">
                  <Mail className="h-5 w-5" />
                </span>
                <span>
                  <span className="block text-xs font-bold uppercase tracking-[0.15em] text-slate-400">Email us</span>
                  <span className="block break-all font-heading text-base font-bold text-navy-800 group-hover:text-sky-600">
                    {BUSINESS.email}
                  </span>
                </span>
              </a>
              <div className="flex items-center gap-4 rounded-2xl border border-slate-100 bg-white p-5 shadow-lg shadow-sky-900/5" data-testid="contact-area-card">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-emerald-50 text-emerald-600">
                  <MapPin className="h-5 w-5" />
                </span>
                <span>
                  <span className="block text-xs font-bold uppercase tracking-[0.15em] text-slate-400">Service area</span>
                  <span className="block font-heading text-base font-bold text-navy-800">
                    {BUSINESS.area} <span className="block text-xs font-medium text-slate-500">Based in Belmore NSW 2192</span>
                  </span>
                </span>
              </div>
              <div className="flex items-center gap-4 rounded-2xl border border-slate-100 bg-white p-5 shadow-lg shadow-sky-900/5" data-testid="contact-hours-card">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-sky-50 text-sky-600">
                  <Clock className="h-5 w-5" />
                </span>
                <span>
                  <span className="block text-xs font-bold uppercase tracking-[0.15em] text-slate-400">Business hours</span>
                  <span className="block font-heading text-base font-bold text-navy-800">{BUSINESS.hours}</span>
                </span>
              </div>
            </div>
            <div className="mt-8 flex flex-wrap gap-4">
              <a href={BUSINESS.phoneHref} data-testid="contact-call-button" className="btn-navy">
                <Phone className="h-4 w-4" /> Call Us
              </a>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.12} className="lg:col-span-3">
          <QuoteForm />
        </Reveal>
      </div>
    </section>
  </>
);

export default Contact;
